<template>
  <div 
    v-if="project.acf.teaser_image"
    class="stream-item hidden" 
    :data-id="project.id" 
    v-on:click="resizeHandler"
    :style="'width:'+ width +'%'"
    >
    <GridItemContent
      v-if="project"
      v-bind:index="index"
      v-bind:project.sync="project"
      v-bind:projectSlug="projectSlug"
      v-bind:width="width"
    />
    <div class="padding-pusher" :style="'padding-top:'+ paddingTop +'%'"></div>
  </div>
</template>


<script>
import GridItemContent from './grid-item-content';

export default {
  name: 'GridItemContainer',
  props: {
    index: Number,
    project: Object,
    projectSlug: String,
  },
  components: {
    GridItemContent,
  },
  data () {
    return {
      width: '',
      paddingTop: ''
    }
  },
  methods: {
    resizeHandler(){
      if( this.project ){
        if( window.innerWidth < 640 ){ // ratio 3/2 on mobile
          this.width = 100
          this.paddingTop = 66.6
        }
        // on tablet 2 rows  
        else if( window.innerWidth < 1000 ){
          this.width = this.project.widthHalf
          this.paddingTop = this.project.paddingTop
        }
        // on desktop 3 rows  
        else{
          this.width = this.project.widthThird
          this.paddingTop = this.project.paddingTop
        }
      }
    }
  },
  created: function(){
    this.resizeHandler();
  },
  mounted: function () {
    window.addEventListener('resize', this.resizeHandler)
  }
}
</script>


<style type="text/css" lang="scss" scoped>

@for $i from 1 through 20 { 
  .stream-item:nth-child(#{$i}){
      transition-delay: $i * 0.07s;
  }
}

.stream-item{
  position: relative;
  display: table;
  width: auto;
  
  cursor: pointer;


  opacity: 1;
  visibility: visible;
  transform: translate(0,0);
  transition: 0.5s;
  transition-property: opacity, transform; 
  transition-timing-function: easeOut;
  
  transform-origin: center top;
  overflow: hidden;


  &.opacity-null{
    opacity: 0.00001;
    visibility: hidden;
    transition: 0;

  }

  &.hidden{
      background-color: transparent;
      opacity: 0.0001;
      transform: translate(0, 100%) scale(0.9) rotateX(-45deg);

  }

  &.hide{
    opacity: 0!important;
    visibility: hidden;
    transition: 0s;
    transition-delay: 0s;
  }

  a, .padding-pusher{
    position: relative;
    z-index: 5;
  }

  a{
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
  }
}

#app.immediate .stream-item{
  opacity: 1;
  transform: translate(0, 0) scale(1) rotateX(0deg);
  transition: 0;
}

// speed up test
.stream-item{
  backface-visibility: hidden;
  will-change: filter;
  transform: translateZ(0);
}

</style>